const userHelper = require('od-modules/helpers/user');
const travellerData = require('od-modules/data/traveller');
const {dispatch} = require('od-modules/secure_store/store');
const {SET_USER_LOGGED} = require('od-modules/secure_store/actions');

module.exports = Odigeo.Model.extend({
    dataURL: null,
    action: null,
    timeout: null,
    method: null,
    userDTO: null,
    userUrls: {
        register: {
            dataURL: 'register',
        },
        registerFullUser: {
            dataURL: 'registerfulluser',
        },
        activateAccount: {
            dataURL: 'activateaccount',
        },
        login: {
            dataURL: 'login',
            data: {
                'class': 'PasswordUserCredentialsDTO',
            },
        },
        loginWithToken: {
            dataURL: 'login',
            data: {
                'class': 'AutoLoginTokenUserCredentialsDTO',
            },
        },
        loginWithFacebook: {
            dataURL: 'login',
            data: {
                'class': 'FacebookUserCredentialsDTO',
            },
        },
        logInAndUpdateAccount: {
            dataURL: 'loginandupdateaccount',
        },
        registerWithFacebook: {
            dataURL: 'login',
            data: {
                'class': 'FacebookUserCredentialsDTO',
            },
        },
        registerWithGoogle: {
            dataURL: 'login',
            data: {
                'class': 'GoogleUserCredentialsDTO',
            },
        },
        loginWithGoogle: {
            dataURL: 'login',
            data: {
                'class': 'GoogleUserCredentialsDTO',
            },
        },
        isLoggedIn: {
            dataURL: 'isloggedin',
        },
        recoverPassword: {
            dataURL: 'recoverpassword',
        },
        changePassword: {
            dataURL: 'changepassword',
        },
        changePasswordWithCode: {
            dataURL: 'changepasswordwithcode',
        },
        changeEmail: {
            dataURL: 'changeemail',
        },
        getAccountInfo: {
            dataURL: 'getaccountinfo',
        },
        updateAccountInfo: {
            dataURL: 'updateaccountinfo',
        },
        cancelAccount: {
            dataURL: 'cancelaccount',
        },
        logOut: {
            dataURL: 'logout',
        },
        getMyTrips: {
            dataURL: 'mytrips',
            timeout: 20000,
        },
        removeSession: {
            dataURL: 'mytrips',
            type: 'DELETE',
        },
        getCreditCard: {
            dataURL: 'getcreditcardinfo',
        },
        addCreditCards: {
            dataURL: 'creditcard',
            type: 'PUT',
        },
        deleteCreditCards: {
            dataURL: 'deleteCreditcard',
            type: 'POST',
        },
        setLastUsageCreditCards: {
            dataURL: 'creditcard',
        },
        isUserRegistered: {
            dataURL: 'isuserregistered',
        },
        getTrip: {
            dataURL: 'trip',
            type: 'GET',
        },
        getSearches: {
            dataURL: 'searches',
            type: 'GET',
        },
        deleteSearches: {
            dataURL: 'deleteSearches',
            type: 'POST',
        },
        addSearch: {
            dataURL: 'searches',
            type: 'PUT',
        },
        getEncryptedTrip: {
            dataURL: 'encryptedTrip',
            type: 'GET',
        },
        getManageBookingToken: {
            dataURL: 'managebookingtoken',
            type: 'GET',
        },
        getCheckin: {
            dataURL: 'checkin',
            type: 'GET',
        },
    },
    travellerModel: require('od-modules/data/traveller'),
    loginType: {
        login: 'mail',
        changePasswordWithCode: 'mail',
        loginWithFacebook: 'facebook',
        registerWithFacebook: 'facebook',
        logInAndUpdateAccount: 'facebook',
        loginWithGoogle: 'google',
        registerWithGoogle: 'google',
    },
    // method overriden from Odigeo
    afterLoadData: Function.prototype,

    getDataRequestSettings: function() {
        var data = this._formatRequestData();
        var type = (this.userUrls[this.action] && !!this.userUrls[this.action].type) ? this.userUrls[this.action].type : 'POST';
        return {
            type: type,
            timeout: this.timeout ? this.timeout : 10000,
            data: type !== 'GET' ? (typeof data === 'string' ? data : JSON.stringify(data)) : '',
            contentType: 'application/json;charset=UTF-8',
            dataType: 'json',
            cache: false,
            success: Odigeo._.bind(this.requestSuccessHandler, this, this.action),
            error: Odigeo._.bind(this.requestErrorHandler, this, this.action),
        };
    },

    _formatRequestData: function() {
        if (!Odigeo._.isNull(this.action) && !Odigeo._.isUndefined(this.userUrls[this.action])) {
            return this.userUrls[this.action].data ? Odigeo._.extend(this.userUrls[this.action].data, this.get('data')) : this.get('data');
        }
        return null;
    },

    addUserRequest: function(params) {
        this.set({'data': (params && params.data) ? params.data : {}});
        this.set('isMemberAction', params && params.isMemberAction, {silent: true});
        if (params && params.action && !Odigeo._.isEmpty(this.userUrls[params.action])) {
            this.dataURL = this.userUrls[params.action].dataURL;
            if (!Odigeo._.isEmpty(this.get('data').queryParams)) {
                this.dataURL += '/?' + Odigeo._.map(this.get('data').queryParams, function(val, key) {
                    return key + '=' + val;
                }).join('&');
            }
            this.isEmptyData = false;
            this.action = params.action;
            this.timeout = this.userUrls[params.action].timeout;
            this.method = this.userUrls[params.action].method;
            this.refresh();
        }
    },

    url: function() {
        return Odigeo.Settings.getProperty('serviceUsersFormatter')(this.dataURL);
    },

    isLoginAction: function(action) {
        return Odigeo._.includes(['login', 'loginWithGoogle', 'loginWithFacebook'], action);
    },

    requestSuccessHandler: function(action, response) {
        let isMembership = false;
        let actionResponse = 'WithError';
        const data = Odigeo._.isObject(response) && Odigeo._.isObject(response.attributes) ? response.attributes : response;
        const hasEmailMatchingError = this.handleNonMatchingEmailError(data, action);

        if (!hasEmailMatchingError && (data === true || (Odigeo._.isObject(data) && data.responseOK))) {
            if (data && !Odigeo._.isEmpty(data.userDTO)) {
                isMembership = data.membership;
                this.set('userDTO', data.userDTO);
                if (Odigeo.AB.sidebarRevamp && this.isLoginAction(action) || action === 'isLoggedIn') {
                    dispatch({type: SET_USER_LOGGED, entry: data.userDTO});
                }
                this.triggerMembershipEvent(this.isLoginAction(action) && isMembership, 'membershipLogInServerConfirmation');
            }
            if (action === 'logOut') {
                Odigeo.Utils.eraseCookie('sso_remember_me');
                Odigeo.Session.set('dontDisplayGoogleOneTap', true);
                if (Odigeo.AB.sidebarRevamp) {
                    dispatch({type: SET_USER_LOGGED, entry: null});
                }
                this.triggerMembershipEvent(this.get('isMemberAction'), 'membershipLogoutServerConfirmation');
            } else if (Odigeo._.has(this.loginType, action)) {
                const REMEMBER_ME_EXPIRATION_IN_DAYS = 390;
                Odigeo.Utils.createCookie('sso_remember_me',
                    encodeURIComponent(this.get('userDTO').email + ';' + this._getUserName() + ';' +
                        isMembership + ';' + this.loginType[action]), REMEMBER_ME_EXPIRATION_IN_DAYS);
            }
            actionResponse = 'Ok';
        }
        this.triggerResponse(action + actionResponse, data);
    },

    handleNonMatchingEmailError: function(data, action) {
        if (!userHelper.isCheckUserMail() || !data.responseOK || !this.isLoginAction(action)) {
            return false;
        }
        const hasError = !userHelper.isLoginMatchesBuyer(data.userDTO.email);
        if (hasError) {
            data.messageError = 'OPRIME_001';
        }
        return hasError;
    },

    triggerMembershipEvent: function(hasToTrigger, eventName) {
        return hasToTrigger ? this.triggerResponse(eventName) : null;
    },

    requestErrorHandler: function(action, xhr) {
        this.triggerResponse(action + 'Error', Odigeo._.extend(xhr, {action: action}));
    },

    triggerResponse: function(action, data) {
        Odigeo.trigger(this.widget.id + ':' + action, Odigeo._.extend(data === true ? {} : data, {action: action}));
    },

    clearUser: function() {
        this.clear();
        this.dataURL = null;
        this.isEmptyData = true;
    },

    saveAllData: function(travellersInfo) {
        Odigeo._.each(travellersInfo.passengers, Odigeo._.bind(function(passenger) {
            this.savePassenger(passenger);
        }, this));
        this.saveContactDetails(travellersInfo.contactDetails);
    },
    saveAllDataWithoutOverwriteTravellers: function(travellersInfo) {
        Odigeo._.each(travellersInfo.passengers, Odigeo._.bind(function(passenger) {
            if (passenger.storedTravellerId !== 0) {
                const storedTraveller = Odigeo._.findWhere(this.get('userDTO').traveller, {id: passenger.storedTravellerId});
                const baseStoredTraveller = storedTraveller ? storedTraveller : this.travellerModel;
                const gender = passenger.travellerGender ? passenger.travellerGender : baseStoredTraveller.profile.gender;

                const newProfile = {
                    ...baseStoredTraveller.profile,
                    ...passenger,
                    gender,
                    travellerType: undefined,
                    travellerGender: undefined,
                    storedTravellerId: undefined,
                    passengerCardNumber: undefined,
                    address: storedTraveller? storedTraveller.profile.address : null,
                    title: gender === 'MALE' ? 'MR': 'MS',
                };
                const newStoredTravellerInfo = {
                    ...baseStoredTraveller,
                    frequentFlyerList: passenger.passengerCardNumber
                        ? passenger.passengerCardNumber : baseStoredTraveller.frequentFlyerList,
                    typeOfTraveller: passenger.travellerType,
                    profile: newProfile,
                };
                newStoredTravellerInfo.typeOfTraveller = passenger.travellerType;
                this.savePassenger({traveller: newStoredTravellerInfo});
            }
        }, this));
        this.saveContactDetails(travellersInfo.contactDetails);
    },

    updateUserModel: function() {
        this.get('userDTO').traveller = Odigeo._.without(this.get('userDTO').traveller, Odigeo._.findWhere(this.get('userDTO').traveller, {id: 0}));
    },

    saveAllPassengersDataWithoutOverwrite: function(travellersInfo) {
        this.updateUserModel();
        this.saveAllDataWithoutOverwriteTravellers(travellersInfo);
        this.updateUserData();
    },

    saveAllPassengersData: function(travellersInfo) {
        this.updateUserModel();
        this.saveAllData(travellersInfo);
        this.updateUserData();
    },

    mixUserAndMember: function(userDTO) {
        var passenger;
        const isDpCondition = Odigeo.AB.isDynpackPrimeEnable || !Odigeo._.isEqual(Odigeo.Utils.getAppInGlobalScope(), 'dp');
        if (userHelper.isUserDTOMember(userDTO) && isDpCondition) {
            passenger = userDTO.membershipInfoDTO.membershipDTO;
            userDTO.traveller.push($.extend(true, {}, travellerData, {
                id: 0,
                typeOfTraveller: 'ADULT',
                profile: {
                    title: 'MR',
                    name: passenger.name,
                    firstLastName: passenger.lastNames,
                }}));
        }
    },

    _getDefaultTraveller: function() {
        var travellers = this.get('userDTO').traveller;
        return Odigeo._.find(travellers, function(traveller) {
            return (traveller.profile) ? traveller.profile.isDefault : false;
        });
    },

    _updateContactDetails: function(trav, contactDetails) {
        trav.profile.address = contactDetails.profile.address;
        trav.profile.prefixPhoneNumber = contactDetails.profile.prefixPhoneNumber;
        trav.profile.phoneNumber = contactDetails.profile.phoneNumber;
        trav.profile.firstLastName = Odigeo._.isEmpty(trav.profile.firstLastName) ?
            contactDetails.profile.firstLastName : trav.profile.firstLastName;
    },

    _getUserName: function() {
        var defaultTraveller = this._getDefaultTraveller();
        return Odigeo._.isUndefined(defaultTraveller) ? this.get('userDTO').email.split('@')[0] : defaultTraveller.profile.name;
    },

    saveContactDetails: function(contactDetails) {
        var trav;
        if (!Odigeo._.isEmpty(this.get('userDTO')) && !Odigeo._.isEmpty(contactDetails)) {
            // Save contact details data
            if (Odigeo._.isNumber(contactDetails.id) && contactDetails.id !== -1 && contactDetails.id !== 0) {
                // Update the traveller that already exits
                trav = Odigeo._.find(this.get('userDTO').traveller, {id: contactDetails.id});
                this._updateContactDetails(trav, contactDetails);
            } else {
                // Insert
                trav = this._getDefaultTraveller();
                // New passenger (Is not the main traveller)
                if (Odigeo._.isObject(trav)) {
                    if (!Odigeo._.isUndefined(trav.id)) {
                        this.get('userDTO').traveller.push(contactDetails);
                    } else {
                        this._updateContactDetails(trav, contactDetails);
                    }
                }
            }
        }
    },

    savePassenger: function(data) {
        var traveller = data.traveller;
        var saveAfterUpdate = data.saveAfterUpdate ? data.saveAfterUpdate : false;
        var trav;

        if (!Odigeo._.isEmpty(this.get('userDTO')) && !Odigeo._.isEmpty(traveller)) {
            if (!Odigeo._.isNumber(traveller.id)) {
                // insert
                traveller.profile.isDefault = Odigeo._.isEmpty(this.get('userDTO').traveller) ? true : traveller.profile.isDefault;
                this.get('userDTO').traveller.push(traveller);
            } else {
                // update
                trav = Odigeo._.find(this.get('userDTO').traveller, {id: traveller.id});
                Odigeo._.extend(trav, traveller);
            }
        }
        if (saveAfterUpdate) {
            this.updateUserData();
        }
    },

    saveUserProfile: function(data) {
        var profile = data.profile;
        var saveAfterUpdate = data.saveAfterUpdate;
        if (!Odigeo._.isEmpty(this.get('userDTO')) && !Odigeo._.isEmpty(profile)) {
            this.get('userDTO').profile = profile;
        }
        if (saveAfterUpdate) {
            this.updateUserData();
        }
    },

    updateUserData: function() {
        this.addUserRequest({'data': this.get('userDTO'), 'action': 'updateAccountInfo'});
    },

    deletePassenger: function(data) {
        if (!Odigeo._.isEmpty(this.get('userDTO')) && data && data.id) {
            this.get('userDTO').traveller = Odigeo._.without(
                this.get('userDTO').traveller,
                Odigeo._.find(this.get('userDTO').traveller, {id: data.id})
            );
            if (data.saveAfterUpdate) {
                this.updateUserData();
            }
        }
    },
});
